import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss'],
})
export class ImageModalComponent implements OnInit {
  url = '';
  studyFile: any;
  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {
    // console.log(this.studyFile)
  }

  closePopup(): void {
    this.modal.close();
  }
}
